module.exports = __webpack_public_path__ + "img/pic4.d19e6db1.jpg";